module.exports = __webpack_public_path__ + "static/fgs-9268de10d02d3e8f8e3e283b66d56cd5.jpg";